module.exports = __webpack_public_path__ + "static/media/couch3.c662a8ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/couch3.svg
// module id = 1122
// module chunks = 38